<template>
  <div>
    <div data-v-d8ce3802="" data-v-e5781868="" class="mask register" style="display: none">
      <div data-v-d8ce3802="" class="panel panel2">
        <div data-v-d8ce3802="" class="close"></div>
        <div data-v-d8ce3802="" class="group">
          <div data-v-d8ce3802="" class="tab">
            <a data-v-d8ce3802="" class="mobile active" style="margin-left: 0">
              用户注册
              <div data-v-d8ce3802="" class="tag">推荐</div>
            </a>
          </div>
          <div data-v-d8ce3802="" class="form">
            <form data-v-d8ce3802="">
              <div data-v-d8ce3802="" class="form-group">
                <div data-v-d8ce3802="" class="form-input-group">
                  <svg data-v-338e1447="" data-v-d8ce3802="" aria-hidden="true" class="icon-phone svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterAccount"></use>
                  </svg>
                  <input data-v-d8ce3802="" v-model="registerInfo.name" type="text" readonly onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly',true);" placeholder="请输入帐号（最少6位，英文及数字）" class="register-password" />
                  <i data-v-d8ce3802="" class="icon-success" style="display: none"></i>
                  <div data-v-d8ce3802="" class="error-message" style="display: none"><span data-v-d8ce3802=""></span></div>
                </div>
                <div data-v-d8ce3802="" class="clear"></div>
              </div>
              
              <div data-v-d8ce3802="" class="form-group">
                <div data-v-d8ce3802="" class="form-input-group">
                  <svg data-v-338e1447="" data-v-d8ce3802="" aria-hidden="true" class="icon-phone svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterPassword"></use>
                  </svg>
                  <input data-v-d8ce3802="" v-model="registerInfo.password" type="password" autocomplete="new-password" placeholder="请输入密码（至少8位，英文及数字）" class="register-password" />
                  <i data-v-d8ce3802="" class="icon-success" style="display: none"></i>
                  <div data-v-d8ce3802="" class="error-message" style="display: none"><span data-v-d8ce3802=""></span></div>
                </div>
                <div data-v-d8ce3802="" class="clear"></div>
              </div>
              
              <div data-v-d8ce3802="" class="form-group">
                <div data-v-d8ce3802="" class="form-input-group">
                  <svg data-v-338e1447="" data-v-d8ce3802="" aria-hidden="true" class="icon-phone svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterPassword"></use>
                  </svg>
                  <input data-v-d8ce3802="" v-model="registerInfo.confirmPass" type="password" placeholder="请再次输入账号密码" class="register-password" />
                  <i data-v-d8ce3802="" class="icon-success" style="display: none"></i>
                  <div data-v-d8ce3802="" class="error-message" style="display: none"><span data-v-d8ce3802=""></span></div>
                </div>
                <div data-v-d8ce3802="" class="clear"></div>
              </div>
              
              <div data-v-d8ce3802="" class="form-group">
                <div data-v-d8ce3802="" class="form-input-group">
                  <svg data-v-338e1447="" data-v-d8ce3802="" aria-hidden="true" class="icon-phone svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterAccount"></use>
                  </svg>
                  <input data-v-d8ce3802="" v-model="registerInfo.realname" type="text" placeholder="请输入真实姓名" class="register-password" />
                  <i data-v-d8ce3802="" class="icon-success" style="display: none"></i>
                  <div data-v-d8ce3802="" class="error-message" style="display: none"><span data-v-d8ce3802=""></span></div>
                </div>
                <div data-v-d8ce3802="" class="clear"></div>
              </div>
              
              <div data-v-d8ce3802="" class="form-group">
                <div data-v-d8ce3802="" class="form-input-group">
                  <svg data-v-338e1447="" data-v-d8ce3802="" aria-hidden="true" class="icon-phone svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterPassword"></use>
                  </svg>
                  <input data-v-d8ce3802="" v-model="registerInfo.paypassword" type="password" maxlength="6" placeholder="请输入6位取款密码" class="register-password" />
                  <i data-v-d8ce3802="" class="icon-success" style="display: none"></i>
                  <div data-v-d8ce3802="" class="error-message" style="display: none"><span data-v-d8ce3802=""></span></div>
                </div>
                <div data-v-d8ce3802="" class="clear"></div>
              </div>

              <div data-v-d8ce3802="" class="form-group">
                <div data-v-d8ce3802="" class="form-input-group">
                  <svg data-v-338e1447="" data-v-d8ce3802="" aria-hidden="true" class="icon-phone svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterAccount"></use>
                  </svg>
                  <input data-v-d8ce3802="" v-model="registerInfo.code" type="text" maxlength="4" placeholder="请输入验证码" class="register-password" />
                  <!-- 注册表单的Canvas验证码 -->
                  <canvas 
                    style="cursor: pointer; height: 35px; position: absolute; right: 2px; top: 2px" 
                    ref="registerCaptcha" 
                    @click="generateRegisterCaptcha"
                    alt="验证码，点击刷新"
                  ></canvas>
                </div>
                <div data-v-d8ce3802="" class="clear"></div>
              </div>
              
              <a data-v-d8ce3802="" class="submit" @click="register">立即开户</a>
            </form>
            <div data-v-d8ce3802="" class="to-login">已有账号 <span data-v-d8ce3802="" @click="loginBox()">去登录 &gt;</span></div>
          </div>
          <p data-v-d8ce3802="" class="note">*{{ $store.state.appInfo.title }}支持数字币存取 <span data-v-d8ce3802="">安全 · 便捷 · 秒到账</span></p>
        </div>
        <div data-v-56bf0195="" data-v-d8ce3802="" class="register-right-panel">
          <div data-v-56bf0195="" class="marquee">
            <div data-v-56bf0195="" class="marquee-title"><i data-v-56bf0195=""></i>15798人成功领取存款3重礼, 累计派发9307062.24USDT</div>
            <div data-v-56bf0195="" class="marquee-box" style="height: 112px">
              <ul data-v-56bf0195="" class="marquee-list">
                <li data-v-56bf0195="">恭喜 ****720会员存款 1,000.00USDT 领取 300.00USDT</li>
                <li data-v-56bf0195="">恭喜 ****an1会员存款 5,000.00USDT 领取 1,750.00USDT</li>
                <li data-v-56bf0195="">恭喜 ****an1会员存款 3,000.00USDT 领取 900.00USDT</li>
                <li data-v-56bf0195="">恭喜 ****gge会员存款 30,000.00USDT 领取 10,500.00USDT</li>
                <li data-v-56bf0195="">恭喜 ****888会员存款 3,000.00USDT 领取 900.00USDT</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div data-v-1f42395c="" data-v-e5781868="" class="mask login" style="display: none">
      <div data-v-1f42395c="" class="login-wrap">
        <div data-v-1f42395c="" class="login-dialog">
          <div data-v-1f42395c="" class="t">贵宾您好，欢迎登录{{ $store.state.appInfo.title }}</div>
          <div data-v-1f42395c="" class="c">
            <form data-v-1f42395c="" id="login">
              <div data-v-1ebe6292="" class="validate" style="color: red" v-if="message">
                <i data-v-1ebe6292="" class="sprites"></i><span data-v-1ebe6292="" class="message">{{ message }}</span>
              </div>

              <div data-v-1f42395c="" class="input-wrapper">
                <svg data-v-338e1447="" data-v-1f42395c="" aria-hidden="true" class="icon-user svg-icon">
                  <use data-v-338e1447="" xlink:href="#icon-loginRegisterAccount"></use>
                </svg>
                <input data-v-1f42395c="" type="text" placeholder="请输入账号" v-model="loginInfo.name" class="input" />
                <div data-v-1f42395c="" class="error sprites" style="display: none"></div>
                <div data-v-1f42395c="" class="clear"></div>
              </div>
              
              <div data-v-1f42395c="" class="input-wrapper">
                <div data-v-1f42395c="" class="input-group">
                  <svg data-v-338e1447="" data-v-1f42395c="" aria-hidden="true" class="icon-password svg-icon">
                    <use data-v-338e1447="" xlink:href="#icon-loginRegisterPassword"></use>
                  </svg>
                  <input data-v-1f42395c="" :type="eyeOpen ? 'text' : 'password'" id="password" name="password" v-model="loginInfo.password" placeholder="请输入密码" class="input" />
                  <div data-v-1f42395c="" @click="changEyeOpen" :class="`eye sprites ${eyeOpen ? 'open' : ''}`"></div>
                </div>
              </div>
              
              <div data-v-1f42395c="" class="input-wrapper">
                <svg data-v-338e1447="" data-v-1f42395c="" aria-hidden="true" class="icon-user svg-icon">
                  <use data-v-338e1447="" xlink:href="#icon-loginRegisterPassword"></use>
                </svg>
                <input data-v-1f42395c="" type="text" placeholder="请输入验证码" v-model="loginInfo.code" class="input" />
                <!-- 登录表单的Canvas验证码 -->
                <canvas 
                  style="cursor: pointer; height: 35px; position: absolute; right: 2px; top: 2px" 
                  ref="loginCaptcha" 
                  @click="generateLoginCaptcha"
                  alt="验证码，点击刷新"
                ></canvas>
              </div>
              
              <a data-v-1f42395c="" class="forget-password" @click="forgetBox()">忘记账号/密码？</a>
              <div data-v-1f42395c="" class="clear"></div>
              <div data-v-1f42395c="" class="button"><a data-v-1f42395c="" class="modal-btn" @click="login">立即登录</a></div>
              <p data-v-1f42395c="">还没有{{ $store.state.appInfo.title }}账户？ <a data-v-1f42395c="" @click="registerBox()">极速开户 &gt;</a></p>
            </form>
          </div>
          <div data-v-1f42395c="" class="shareholder"><img data-v-1f42395c="" src="/static/image/login_footer.57c23c6d.png" /></div>
        </div>
        <img data-v-1f42395c="" src="/static/image/login-04cb6e544bed551bfc859201480b06034.png_.webp" class="login-img" />
        <div data-v-1f42395c="" class="close"></div>
      </div>
    </div>
    
    <div data-v-1bc5efd2="" data-v-e5781868="" class="mask forget" style="display: none">
      <div data-v-1bc5efd2="" class="forgetPassword modal">
        <div data-v-1bc5efd2="" class="t">
          登录时遇到问题了？
          <div data-v-1bc5efd2="" class="close"></div>
        </div>
        <div data-v-1bc5efd2="" class="c">
          <form data-v-1bc5efd2="">
            <div data-v-1bc5efd2="" class="input-wrapper">
              <div data-v-1bc5efd2="" class="radio-label">
                <input data-v-1bc5efd2="" type="radio" value="forgetPassword" checked="checked" name="radio1" id="radio1" />
                <label data-v-1bc5efd2="" for="radio1"><i data-v-1bc5efd2=""></i> <span data-v-1bc5efd2="" class="msg">我忘记密码了</span></label>
              </div>
            </div>
            <div data-v-1bc5efd2="" class="input-wrapper">
              <div data-v-1bc5efd2="" class="radio-label">
                <input data-v-1bc5efd2="" type="radio" value="forgetAccount" name="radio1" id="radio2" />
                <label data-v-1bc5efd2="" for="radio2"><i data-v-1bc5efd2=""></i> <span data-v-1bc5efd2="" class="msg">我忘记游戏账号了</span></label>
              </div>
            </div>
            <div data-v-1bc5efd2="" class="input-wrapper">
              <div data-v-1bc5efd2="" class="radio-label">
                <input data-v-1bc5efd2="" type="radio" value="forgetAll" name="radio1" id="radio3" />
                <label data-v-1bc5efd2="" for="radio3"><i data-v-1bc5efd2=""></i> <span data-v-1bc5efd2="" class="msg">两个都忘记了</span></label>
              </div>
            </div>
            <div data-v-1bc5efd2="" class="button"><a data-v-1bc5efd2="" @click="openKefu()" class="modal-btn">下一步</a></div>
          </form>
        </div>
      </div>
    </div>
    <div data-v-3e52ce59="" class="loading" style="display: none">
      <div data-v-3e52ce59="" class="loader"><span data-v-3e52ce59="" class="load-img"></span></div>
    </div>
    <div data-v-21135613="" data-v-011e1fb8="" class="confirm-dialog-container outLoginBox" style="display: none">
      <div data-v-21135613="" class="confirm-dialog-inner">
        <div data-v-21135613="" class="confirm-dialog-header">
          <span data-v-21135613="">提示</span><svg @click="closeT" data-v-338e1447="" data-v-21135613="" aria-hidden="true" class="close-button svg-icon iconClose"><use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg>
        </div>
        <div data-v-21135613="" class="confirm-dialog-content">
          <p data-v-21135613="">尊敬的贵宾，您确定要退出当前账号吗？</p>
          <div data-v-21135613="" class="buttons-wrapper"><a data-v-21135613="" href="javascript:void (0);" @click="outLogin" class="cancel-button">确定退出</a><a data-v-21135613="" @click="closeT" href="javascript:void (0);" class="confirm-button">再玩一会</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'allLogin',
  data() {
    return {
      loginInfo: {},
      registerInfo: {},
      eyeOpen: false,
      message: null,
      tishiShow: false,
      check_agree: false,
      // 存储验证码
      loginCaptchaCode: '',
      registerCaptchaCode: ''
    };
  },
  created() {
    // 初始化时不生成验证码，因为DOM还未加载
  },
  mounted() {
    // DOM加载完成后生成验证码
    this.generateLoginCaptcha();
    this.generateRegisterCaptcha();
  },
  methods: {
    /**
     * 生成登录验证码
     */
    generateLoginCaptcha() {
      this.loginCaptchaCode = this.generateCaptcha(this.$refs.loginCaptcha);
    },
    
    /**
     * 生成注册验证码
     */
    generateRegisterCaptcha() {
      this.registerCaptchaCode = this.generateCaptcha(this.$refs.registerCaptcha);
    },
    
    /**
     * 生成验证码的核心方法
     * @param {HTMLCanvasElement} canvas - canvas元素
     * @returns {string} 生成的验证码文本
     */
    generateCaptcha(canvas) {
      if (!canvas) return '';
      
      const ctx = canvas.getContext('2d');
      // 设置canvas大小
      canvas.width = 100;
      canvas.height = 35;
      
      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // 绘制背景
      ctx.fillStyle = this.getRandomColor(200, 255);
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // 验证码字符集 - 排除容易混淆的字符
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
      let code = '';
      
      // 生成4个随机字符
      for (let i = 0; i < 4; i++) {
        const char = chars.charAt(Math.floor(Math.random() * chars.length));
        code += char;
        
        // 绘制字符
        ctx.font = `${16 + Math.random() * 8}px Arial, SimHei, sans-serif`;
        ctx.fillStyle = this.getRandomColor(50, 150);
        ctx.textBaseline = 'middle';
        
        // 字符旋转 (-15° 到 15°)
        const angle = (Math.random() - 0.5) * 0.5;
        ctx.save();
        ctx.translate(20 + i * 20, canvas.height / 2);
        ctx.rotate(angle);
        ctx.fillText(char, 0, 0);
        ctx.restore();
      }
      
      // 添加干扰线
      for (let i = 0; i < 4; i++) {
        ctx.strokeStyle = this.getRandomColor(100, 200);
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }
      
      // 添加干扰点
      for (let i = 0; i < 50; i++) {
        ctx.fillStyle = this.getRandomColor(50, 200);
        ctx.beginPath();
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, 2 * Math.PI);
        ctx.fill();
      }
      
      return code;
    },
    
    /**
     * 生成随机颜色
     * @param {number} min - 最小色值
     * @param {number} max - 最大色值
     * @returns {string} 颜色的rgb表示
     */
    getRandomColor(min, max) {
      const r = min + Math.floor(Math.random() * (max - min + 1));
      const g = min + Math.floor(Math.random() * (max - min + 1));
      const b = min + Math.floor(Math.random() * (max - min + 1));
      return `rgb(${r}, ${g}, ${b})`;
    },
    
    register() {
      let that = this;

      // if (!that.check_agree) {
      //   that.$parent.showTost(0, '请阅读并同意相关条款和隐私协议！');
      //   return;
      // }
      
      let info = {};
      info.name = that.registerInfo.name || '';
      info.password = that.registerInfo.password || '';
      info.confirmPass = that.registerInfo.confirmPass || '';
      info.realname = that.registerInfo.realname || '';
      info.paypassword = that.registerInfo.paypassword || '';
      let code = that.registerInfo.code || '';
      
      // 验证规则
      let namereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; 
      let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/; 
      var realnamereg = /^[\u0391-\uFFE5a-zA-Z·&\\s]+$/; 
      let paypasswordreg = /^.{6,6}$/; 
      
      if (!code || code.toUpperCase() !== that.registerCaptchaCode.toUpperCase()) {
        that.$parent.showTost(0, '验证码错误！');
        that.registerInfo.code = '';
        that.generateRegisterCaptcha(); // 重新生成验证码
        return;
      }
      
      if (!namereg.test(info.name)) {
        that.$parent.showTost(0, '用户名长度不得低于6位，以字母和数字组合！');
        return;
      }

      if (!passwordreg.test(info.password)) {
        that.$parent.showTost(0, '密码长度最少8位！以字母和数字组合！');
        return;
      }
      
      if (info.confirmPass !== info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      
      if (!realnamereg.test(info.realname)) {
        that.$parent.showTost(0, '姓名格式不正确，可以是中，英文名称！');
        return;
      }

      if (!paypasswordreg.test(info.paypassword)) {
        that.$parent.showTost(0, '支付密码长度需是6位！');
        return;
      }
      
      that.$parent.showLoading();
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.getUserInfo();
          that.$parent.openDaoTime();
        }
        that.registerInfo.code = null;
        that.$parent.hideLoading();
        that.generateRegisterCaptcha(); // 重新生成验证码
      });
    },
    
    login() {
      let that = this;
      let info = that.loginInfo;
      
      if (!info.name || !info.password) {
        that.message = '请输入您的账号和密码！';
        return;
      }
      
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');
        return;
      }
      if (code.toUpperCase() !== that.loginCaptchaCode.toUpperCase()) {
        that.$parent.showTost(0, '验证码错误！');
        that.loginInfo.code = null;
        that.generateLoginCaptcha(); // 重新生成验证码
        return;
      }
      
      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.message = res.message;
          that.loginInfo.code = null;
          that.generateLoginCaptcha(); // 重新生成验证码
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.getUserInfo();
          that.$parent.openDaoTime();
          that.generateLoginCaptcha(); // 重新生成验证码
        }
      });
    },
    
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          $('.mask').fadeOut(300);
        }
        that.$parent.hideLoading();
      });
    },
    
    changEyeOpen() {
      this.eyeOpen = !this.eyeOpen;
    },
    
    openKefu() {
      this.$parent.openKefu();
      this.forgetBox();
    },
    
    outLogin() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/logoff', {})
        .then(res => {
          localStorage.clear();
          sessionStorage.clear();
          that.$store.commit('changUserInfo');
          that.$store.commit('changToken');
          that.closeT();
          that.$parent.closeDaoTime();
          setTimeout(() => {
            that.$parent.hideLoading();
            that.$parent.goNav('/');
          }, 1000);
        })
        .catch(() => {
          localStorage.clear();
          sessionStorage.clear();
          that.$store.commit('changUserInfo');
          that.$store.commit('changToken');
          that.closeT();
          that.$parent.closeDaoTime();
          setTimeout(() => {
            that.$parent.hideLoading();
            that.$parent.goNav('/');
          }, 1000);
        });
    },
    
    loginBox() {
      this.loginInfo = {};
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    
    registerBox() {
      this.registerInfo = {};
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
    
    closeT() {
      this.tishiShow = false;
      $('.outLoginBox').fadeOut(300);
    },
    
    goNav(url) {
      let that = this;
      if (url === this.$route.fullPath) {
        that.$parent.showTost(0, '您就在当前页');
        return;
      }
      this.url = url;
      this.$router.push({ path: url });
    },
    
    open(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.login-wrap .login-dialog .c .input-wrapper .input-group[data-v-1f42395c] {
  width: 100%;
}

.form-input-group, .input-wrapper {
  position: relative;
}
</style>
    


// WEBPACK FOOTER //
// src/components/libs/allLogin.vue